const userTestimonials = [
	{
		path: '/agency/user-testimonials/list',
		name: 'agency-user-testimonials-list',
		component: () => import('@/views/agency/user-testimonials/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAG,marketing',
		},
	},
]

export default userTestimonials
